<template>
  <el-dialog
    :visible.sync="visible"
    append-to-body
    :show-close="true"
    :center="true"
    :before-close="handleClose"
    title="付款详情"
    width="500px"
    
  >
    <div>
      <el-form ref="form" :model="formData"   label-width="100px">
       

        <el-form-item label="项目名称" prop="name" >  
          {{ formData.name }}
        </el-form-item>

        <el-form-item label="用户名称" prop="nickname" >  
          {{ formData.nickname }}
        </el-form-item>


        <el-form-item label="金额" prop="money" >  
          {{ formData.money }}
        </el-form-item>



        <el-form-item label="打款描述" prop="content">
          {{ formData.content }}
        </el-form-item>


        <el-form-item label="发起时间" prop="created_at" >
          {{ formData.created_at }}

        </el-form-item>

     
        <el-form-item label="打款状态" prop="created_at" >
          <span v-if="formData.status==1">待确认</span>
          <span v-if="formData.status==2">待完成</span>
          <span v-if="formData.status==3">已完成</span>
          <span v-if="formData.status==4">已取消</span>

        </el-form-item>


      
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">关 闭</el-button>
    </span>


  </el-dialog>
</template>

<script>
import { paymentUserInfo} from "@/api/personal/work/approval/index";

export default {

  data() {
    return {
      visible: false,
      id:"",

      formData: {
        content:"",
        money:"",
        nickname: "",
        name: "",
        created_at: "",
        status: "",
      },
      
    };
  },

 
  mounted() {
    console.log("asdasdasd")

},
  
  methods: {
    handleClose() {
      this.visible = false;
      this.$refs["form"].resetFields();

    },


    init(id) {
      this.id=id;
      this.initData();
      this.visible = true;
    },

    initData(){
      var that=this;
      paymentUserInfo({"id":that.id}).then((response) => {
        console.log(response);
        if(response.code==200){
          that.formData=response.data
        }else{
          this.$message({
            message: response.msg?response.msg:"获取信息失败",
          });
        }
      });

    
    },

  }

 
};
</script>

<style lang="scss" scoped>



::v-deep .myWindow {
    border-radius: 15px;



.el-button--primary {
  color: #FFF;
  background-color: #717ebb;
  border-color: #717ebb;
}


/*
.footer{
  display: flex;
  justify-content: center;
}*/


  }
</style>
